export class MicrosoftAuthorizedEntitiesRequest{
    public customerId!:number;
}
